export const PAGETYPE = {
  submenu: "submenu",
  cnc: "CNC",
  ud: "Utilization Dashboard",
  cd: "Customer Dashboards",
  cw: "Customer Widgets",
  msd: "Machine Schedule Dashboards",
  tms: "TMS",
  tms_alarm: "TMS Alarm",
  iiot: "IIot",
  job_entry: "JOB_ENTRY",
  report: "REPORT",
  plant_setting: "PLANT_SETTING",
  cnc_maintenance: "CNC_MAINTENANCE",
  hennig_alarm: "HENNIG_ALARM",
  hennig_iot: "HENNIG_IOT",
};

export const VIEWMODE = {
  listView: 0,
  tileView: 1,
};

export const MENU_DIVIDER = "___";

export const menuReport = "menu_report";
export const sizeMobile = 768;
export const sizePad = 1100;

// Sensor
export const SENSOR_COMMUNICATION_TYPE = {
  api: 0,
  mqtt: 1,
};

export const SENSOR_COMMUNICATION_TYPE_TITLE = {
  api: "API",
  mqtt: "MQTT",
};

export const SENSOR_TYPE = {
  other: 0,
  temperature: 1,
  current: 2,
  vibration: 3,
  moisture: 4,
  weight: 5,
  tempAndHum: 6,
  phaseguard: 7,
  henningvariflow: 8,
  henningultraflow8x1: 9,
  henningultraflow8x2: 10,
  henningultraflow16x1: 11,
  henningmistflow: 12,
  henningpowercheck: 13,
};

export const SENSOR_TITLE_BY_ID = {
  other: "Other",
  temperature: "Temperature Probe",
  current: "Current Sensor",
  vibration: "Vibration Sensor",
  moisture: "Moisture Sensor",
  weight: "Weight Sensor",
  tempAndHum: "Temperature and Humidity",
  phaseguard: "Phase Guard",
  henningvariflow: "Henning Variflow",
  henningultraflow8x1: "Henning UltraFlow 8x1",
  henningultraflow8x2: "Henning UltraFlow 8x2",
  henningultraflow16x1: "Henning UltraFlow 16x1",
  henningmistflow: "Henning MistFlow",
  henningpowercheck: "Henning Power Check",
};

export const SENSOR_UNIT_BY_ID = {
  other: [""],
  temperature: ["°C", "°F", ""],
  current: ["mA", "A", ""],
  vibration: ["Hz", ""],
  moisture: ["%", ""],
  weight: ["kg", "lbs"],
  tempAndHum: ["F", "C"],
  phaseguard: ["p1", "p2"],
  henningvariflow: ["h1", "h2"],
  henningultraflow8x1: ["h1", "h2"],
  henningultraflow8x2: ["h1", "h2"],
  henningultraflow16x1: ["h1", "h2"],
  henningmistflow: ["h1", "h2"],
  henningpowercheck: ["h1", "h2"],
};

export const SENSOR_ALERT_FREQUENCY = {
  noAlert: 0,
  min5: 5,
  min10: 10,
  min20: 20,
  hr1: 60,
};

export const SENSOR_ALERT_FREQUENCY_TITLE = {
  noAlert: "no alert",
  min5: "5 min",
  min10: "10 min",
  min20: "20 min",
  hr1: "1 hour",
};
// Sensor

//Hennig
export const HENNIG_TYPE = {
  other: 0,
  temperature: 1,
  current: 2,
  vibration: 3,
  moisture: 4,
  weight: 5,
  tempAndHum: 6,
};
export const HENNIG_TITLE_BY_ID = {
  other: "Other",
  temperature: "Temperature Probe",
  current: "Current Sensor",
  vibration: "Vibration Sensor",
  moisture: "Moisture Sensor",
  weight: "Weight Sensor",
  tempAndHum: "Temperature and Humidity",
};
export const HENNIG_UNIT_BY_ID = {
  other: [""],
  temperature: ["°C", "°F", ""],
  current: ["mA", "A", ""],
  vibration: ["Hz", ""],
  moisture: ["%", ""],
  weight: ["kg", "lbs"],
  tempAndHum: ["F", "C"],
};
export const HENNIG_ALERT_FREQUENCY = {
  noAlert: 0,
  min5: 5,
  min10: 10,
  min20: 20,
  hr1: 60,
};
export const HENNIG_ALERT_FREQUENCY_TITLE = {
  noAlert: "no alert",
  min5: "5 min",
  min10: "10 min",
  min20: "20 min",
  hr1: "1 hour",
};
//Hennig

export const laborTimeFormats = ["24hr", "12hr"];
export const laborCategories = [
  "TOS",
  "MMS Site",
  "MMS APK",
  "Fanuc Bridge",
  "Okuma",
];

export const cwTypes = [
  "Trend Chart",
  "Bar Chart",
  "Gauge Chart",
  "Pie Chart",
  "Text Info Box",
  "Machine Info Box",
];

export const cwSizes = ["FullSize", "Half Size"];

export const cwDataPoints = [
  "Good Parts",
  "Bad Parts",
  "OEE",
  "Availability",
  "Quality",
  "Performance",
  "Total In Cycle Time",
];

// export const cwFilters

//Trello Constants
export const trelloColors = [
  "red",
  "red_dark",
  "green",
  "green_dark",
  "blue",
  "blue_dark",
  "yellow",
  "purple",
];

export const STATUS_COLORS = [
  "#ff9600",
  "#ffec00",
  "#549afc",
  "#c000db",
  "#9898db",
  "#B0E0E6",
  "#6aa786",
  "#c0a0c0",
  "#808080",
  "#ff0000",
  "#46c392",
  "#000000",
];

// Predefined color list for downtime reasons (matches Android ColorPickerDialog + res/values/colors.xml).
// Order: original 11 (status_red … black), then 9 new distinct colors (status_orange … status_light_pink).
export const DOWNTIME_REASON_COLORS = [
  "#FF0000", /* status_red */
  "#46C392", /* status_teal */
  "#FFEC00", /* status_yellow */
  "#549AFC", /* status_blue */
  "#C000DB", /* status_purple */
  "#9898DB", /* status_grey_blue */
  "#B0E0E6", /* status_powder_blue */
  "#6AA786", /* status_greenish */
  "#C0A0C0", /* status_violet_grey */
  "#808080", /* status_gray */
  "#000000", /* black */
  "#FF7F00", /* status_orange */
  "#00FF7F", /* status_spring_green */
  "#8B00FF", /* status_violet */
  "#FF1493", /* status_deep_pink */
  "#2E8B57", /* status_sea_green */
  "#7FFF00", /* status_chartreuse */
  "#DC143C", /* status_crimson */
  "#00BFFF", /* status_deep_sky_blue */
  "#FFB6C1", /* status_light_pink */
];

// Downtime reasons: default 8 with colors (match mobile app). Max 20 supported.
export const DEFAULT_DOWNTIME_REASONS = [
  { label: "Clear Chips", color: "#ffec00" },
  { label: "Wait Materials", color: "#549afc" },
  { label: "Wait Tooling", color: "#c000db" },
  { label: "Break", color: "#9898db" },
  { label: "No Operator", color: "#B0E0E6" },
  { label: "P.M.", color: "#6aa786" },
  { label: "Unplanned Repair", color: "#c0a0c0" },
  { label: "Other", color: "#808080" },
];

export const MAX_DOWNTIME_REASONS = 20;

/**
 * Normalize one item from downtime reasons list (from JSON or API).
 * @returns {{ label: string, color: string }}
 */
function normalizeDowntimeItem(item) {
  return {
    label: item && (item.label ?? item.status) != null ? String(item.label ?? item.status) : "",
    color: item && item.color ? String(item.color) : "#808080",
  };
}

/**
 * Get downtime reasons list from app setting response/object.
 * Uses downtime_reasons_setting (new) when available; otherwise original downtime_reason1..8.
 * 1) Prefers downtime_reasons_list (array) when API adds it (e.g. get_app_setting).
 * 2) Else uses downtime_reasons_setting (JSON string) when present (e.g. report API raw row).
 * 3) Else builds from downtime_reason1..8 + default colors (original site / no new column).
 * @param {Object} appSetting - One row from get_app_setting or appSettings[0] from report
 * @returns {Array<{label: string, color: string}>}
 */
export function getDowntimeReasonsFromAppSetting(appSetting) {
  if (!appSetting) return [...DEFAULT_DOWNTIME_REASONS];

  // 1) Prefer downtime_reasons_list (array) – e.g. get_app_setting response
  let list = appSetting.downtime_reasons_list;
  if (Array.isArray(list) && list.length > 0) {
    return list.slice(0, MAX_DOWNTIME_REASONS).map(normalizeDowntimeItem);
  }

  // 2) Use downtime_reasons_setting (JSON string) – e.g. report API returns raw row
  const raw = appSetting.downtime_reasons_setting;
  if (raw != null && typeof raw === "string" && raw.trim() !== "" && raw.trim() !== "null") {
    try {
      list = JSON.parse(raw);
      if (Array.isArray(list) && list.length > 0) {
        return list.slice(0, MAX_DOWNTIME_REASONS).map(normalizeDowntimeItem);
      }
    } catch (_) {
      /* fall through to reason1..8 */
    }
  }

  // 3) Original: build from downtime_reason1..8 + default colors
  const reasons = [];
  for (let i = 1; i <= 8; i++) {
    const label = appSetting[`downtime_reason${i}`];
    const def = DEFAULT_DOWNTIME_REASONS[i - 1];
    reasons.push({
      label: label != null && String(label).trim() !== "" ? String(label).trim() : def.label,
      color: def.color,
    });
  }
  return reasons;
}
